export default __webpack_public_path__ + "static/media/detail_small_9_4.63c329f9.jpg";